export const configKeys = {
  /**
   * Config key for survey uri
   * @type {string}
   */
  SURVEY_API_URI_CONFIG_KEY: 'apis.survey.uri',
  /**
   * Config key for session auth token
   * @type {string}
   */
  SESSION_AUTH_TOKEN: 'session.authToken',

  /**
   * Config key for session tenant id
   * @type {string}
   */
  SESSION_TENANT_ID: 'session.tenantId'
};
